
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestcardprocessingrates/privacy-policy",
      function () {
        return require("private-next-pages/bestcardprocessingrates/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestcardprocessingrates/privacy-policy"])
      });
    }
  